'use es6';

import EmailTemplateModeSelectModalBodyWithBusinessUnit from 'EmailComponents/emailCreation/EmailTemplateModeSelectModalBodyWithBusinessUnit';
import BlogRssFeedSelectModalBody from 'EmailComponents/emailCreation/BlogRssFeedSelectModalBody';
import EmailTypeSelectModalBodyWithBusinessUnit from 'EmailComponents/emailCreation/EmailTypeSelectModalBodyWithBusinessUnit';
import { CREATION_STEPS } from 'EmailData/constants/emailCreation';
import { jsx as _jsx } from "react/jsx-runtime";
function EmailCreationBody({
  availableEmailTypes,
  businessUnitId,
  canAccessBusinessUnit,
  canUseRss,
  currentCreationStep,
  emailBusinessUnitId,
  emailName,
  emailType,
  onClickClassic,
  onClickDragDrop,
  onClose,
  onSelectBlog,
  onSelectBusinessUnit,
  onSelectEmailType,
  onSelectFrequency,
  onSelectRssFeedUrl,
  previewDdUrl,
  rssFeedUrl,
  selectedBlog,
  selectedEmailType,
  selectedFrequency,
  selectedTemplateMode,
  shouldUseBUPicker
}) {
  switch (currentCreationStep) {
    case CREATION_STEPS.TEMPLATE_TYPE:
      return /*#__PURE__*/_jsx(EmailTemplateModeSelectModalBodyWithBusinessUnit, {
        canAccessBusinessUnit: canAccessBusinessUnit,
        emailBusinessUnitId: emailBusinessUnitId,
        emailName: emailName,
        emailType: emailType,
        onCancel: onClose,
        onClickClassic: onClickClassic,
        onClickDragDrop: onClickDragDrop,
        onSelectBusinessUnit: onSelectBusinessUnit,
        previewDdUrl: previewDdUrl,
        selectedTemplateMode: selectedTemplateMode
      });
    case CREATION_STEPS.EMAIL_TYPE:
      return /*#__PURE__*/_jsx(EmailTypeSelectModalBodyWithBusinessUnit, {
        availableEmailTypes: availableEmailTypes,
        canAccessBusinessUnit: canAccessBusinessUnit,
        creationType: "create",
        emailBusinessUnitId: emailBusinessUnitId,
        emailName: emailName,
        onSelectBusinessUnit: onSelectBusinessUnit,
        onSelectType: onSelectEmailType,
        selectedEmailType: selectedEmailType,
        shouldUseBUPicker: shouldUseBUPicker
      });
    case CREATION_STEPS.BLOG_RSS_FEED_SELECT:
      return /*#__PURE__*/_jsx(BlogRssFeedSelectModalBody, {
        businessUnitId: businessUnitId,
        canAccessBusinessUnit: canAccessBusinessUnit,
        canUseRss: canUseRss,
        onSelectBlog: onSelectBlog,
        onSelectFrequency: onSelectFrequency,
        onSelectRssFeedUrl: onSelectRssFeedUrl,
        rssFeedUrl: rssFeedUrl,
        selectedBlog: selectedBlog,
        selectedFrequency: selectedFrequency
      });
    default:
      return null;
  }
}
export default EmailCreationBody;